import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import Button from './Button';

const messages = defineMessages({
  Yes: 'Yes',
  No: 'No',
  DontShowAgain: "Don't show this again",
});

class YesNoModal extends Component {
  state = {
    dontShowAgain: false,
  };

  static propTypes = {
    title: PropTypes.node,
    show: PropTypes.bool,
    onClose: PropTypes.func,
    onSave: PropTypes.func.isRequired,
    onNo: PropTypes.func,
    disabled: PropTypes.bool,
    message: PropTypes.node,
    showDontShowAgain: PropTypes.bool,
    onDontShowAgainChange: PropTypes.func,
  };

  static defaultProps = {
    showDontShowAgain: false,
    onDontShowAgainChange: null,
  };

  handleDontShowAgainChange = (e) => {
    const checked = e.target.checked;
    this.setState({ dontShowAgain: checked });
    
    if (this.props.onDontShowAgainChange) {
      this.props.onDontShowAgainChange(checked);
    }
  };

  handleSave = () => {
    const { onSave } = this.props;
    const { dontShowAgain } = this.state;
    
    // Pass the dontShowAgain state to the parent component and return the result
    // This ensures any promise returned by onSave is properly handled for the spinner
    return onSave(dontShowAgain);
  };

  render() {
    const { 
      title, 
      show, 
      onClose, 
      onNo, 
      disabled, 
      intl, 
      message, 
      showDontShowAgain 
    } = this.props;
    const { dontShowAgain } = this.state;

    return (
      <Modal show={show} onHide={() => (onClose ? onClose() : onNo())}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>{message}</div>
          {showDontShowAgain && (
            <div className="margin10T">
              <label className="checkbox-inline">
                <input
                  type="checkbox"
                  checked={dontShowAgain}
                  onChange={this.handleDontShowAgainChange}
                />
                <span className="margin5L">
                  {intl.formatMessage(messages.DontShowAgain)}
                </span>
              </label>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button showProgress onClick={() => onNo()}>
            {intl.formatMessage(messages.No)}
          </Button>
          <Button
            onClick={this.handleSave}
            disabled={disabled}
            btnClassName="btn-inverse"
            showProgress
          >
            {intl.formatMessage(messages.Yes)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(YesNoModal);
